import { useCallback, useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $generateNodesFromDOM } from '@lexical/html';
import { $getRoot } from 'lexical';

export const DocxDropPlugin: React.FC = () => {
  const [editor] = useLexicalComposerContext();

  const handleDrop = useCallback(
    async (event: DragEvent) => {
      const files = event.dataTransfer?.files;
      if (!files || files.length === 0) return;
      const file = files[0];
      if (
        file.type ===
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.name.endsWith('.docx')
      ) {
        event.preventDefault();
        try {
          const arrayBuffer = await file.arrayBuffer();
          const { convertToHtml } = await import('mammoth');
          const result = await convertToHtml({ arrayBuffer });
          const parser = new DOMParser();
          const dom = parser.parseFromString(result.value, 'text/html');

          editor.update(() => {
            const nodes = $generateNodesFromDOM(editor, dom);
            const root = $getRoot();
            root.clear();
            nodes.forEach((n) => root.append(n));
          });
        } catch (err) {
          console.error('Failed to import .docx file', err);
        }
      }
    },
    [editor]
  );

  useEffect(() => {
    const rootElement = editor.getRootElement();
    if (!rootElement) return;
    rootElement.addEventListener('drop', handleDrop);
    return () => rootElement.removeEventListener('drop', handleDrop);
  }, [editor, handleDrop]);

  return null;
};
